var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('img',_vm._g({attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width,"height":_vm.height,"loading":_vm.priority ? 'eager' : 'lazy',"fetchpriority":_vm.priority ? 'high' : 'low',"decoding":"async"}},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }